module.exports = __webpack_public_path__ + "static/media/createaccounts.846c5acc.svg";